export function timestampToMs(timestamp: string): number | undefined {
  const timeInterval = timestamp.split(':').map((item: string) => {
    return Number(item);
  });

  const isInvalid = timeInterval.some((item, index) => {
    if (isNaN(item)) {
      return true;
    } else {
      if (index === 0) {
        return item > 99;
      } else {
        return item > 59;
      }
    }
  });

  if (timeInterval.length < 3 || isInvalid) {
    return undefined;
  }

  return timeInterval[0] * 3600000 + timeInterval[1] * 60000 + timeInterval[2] * 1000;
}
